var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.post.date)+" ")]),_c('td',[_vm._v(_vm._s(_vm.post.time))]),_c('td',[_vm._v(_vm._s(_vm.post.location))]),(_vm.auth)?_c('td',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":_vm.remove}},[_vm._v("delete")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }